<mat-form-field appearance="outline" class="w-100" [style.fontSize.px]="12" autocomplete="off">
    <input matInput #swiper  (keyup)="onChange($event)" placeholder="Search"  autocomplete="off">
</mat-form-field>